
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface VideoTableHeaderProps {
  selectAll: boolean;
  onToggleSelectAll: () => void;
}

export function VideoTableHeader({ selectAll, onToggleSelectAll }: VideoTableHeaderProps) {
  return (
    <TableHeader className="bg-[#0F111A] border-b border-gray-800/30">
      <TableRow className="hover:bg-transparent">
        <TableHead className="w-[40px] py-4 text-xs uppercase text-gray-400 font-medium">
          <input
            type="checkbox"
            checked={selectAll}
            onChange={onToggleSelectAll}
            className="h-4 w-4 rounded border-gray-600 bg-transparent accent-[#00E5FF]"
            data-testid="select-all-checkbox"
          />
        </TableHead>
        <TableHead className="w-[50px] py-4 text-xs uppercase text-gray-400 font-medium">Cover</TableHead>
        <TableHead className="py-4 text-xs uppercase text-gray-400 font-medium">Caption</TableHead>
        <TableHead className="py-4 text-xs uppercase text-gray-400 font-medium text-right">Views</TableHead>
        <TableHead className="py-4 text-xs uppercase text-gray-400 font-medium text-right">Comments</TableHead>
        <TableHead className="py-4 text-xs uppercase text-gray-400 font-medium text-right">Likes</TableHead>
        <TableHead className="py-4 text-xs uppercase text-gray-400 font-medium text-right">Shares</TableHead>
        <TableHead className="py-4 text-xs uppercase text-gray-400 font-medium text-right">Bookmarks</TableHead>
        <TableHead className="w-[100px] py-4 text-xs uppercase text-gray-400 font-medium text-right">Duration</TableHead>
        <TableHead className="w-[140px] py-4 text-xs uppercase text-gray-400 font-medium text-right">Date posted</TableHead>
        <TableHead className="w-[50px] py-4 text-center text-xs uppercase text-gray-400 font-medium">Action</TableHead>
      </TableRow>
    </TableHeader>
  );
}
